import { Link } from "react-router-dom";
import { Bell, HeartHandshake } from "lucide-react";
import { Money } from "@/components/shared/Money";
import { EVENT_KINDS, whenLabel, yearsLabel } from "@/lib/events";

const bill = (b) => {
  if (b.days_left === 0) return `${b.label} vence hoje`;
  if (b.days_left === 1) return `${b.label} vence amanhã`;
  if (b.days_left === 2) return `${b.label} vence em 2 dias`;
  return `${b.label} passou do dia ${b.due_day}`;
};

const moment = (e) => {
  const when = e.days_left === 0 ? "é hoje" : `${whenLabel(e.days_left)}`;
  const years = e.years ? ` — ${yearsLabel(e.years)}` : "";
  const time = e.days_left === 0 && e.time ? ` às ${e.time}` : "";
  return `${e.title} ${when}${time}${years}`;
};

export const Reminders = ({ s }) => {
  const items = (s.reminders || []).map((b) => ({ key: b.id, icon: Bell, text: bill(b), amount: b.amount, to: "/dinheiro?tab=calendario", overdue: b.days_left < 0 }));
  (s.upcoming_events || []).forEach((e) => {
    const k = EVENT_KINDS[e.kind] || EVENT_KINDS.momento;
    items.push({ key: `ev-${e.id}-${e.date}`, icon: k.icon, color: k.color, text: moment(e), to: `/dinheiro?tab=calendario&d=${e.date}`, soon: e.days_left <= 1 });
  });
  const sunday = s.weekday === 6;
  if (sunday && !s.checkin_this_week) items.unshift({ key: "checkin", icon: HeartHandshake, text: "Domingo. Dez minutos pro check-in da semana?", to: "/vida?tab=checkin" });
  if (items.length === 0) return null;
  return (
    <ul className="mt-6 space-y-2 rise rise-1" data-testid="reminders">
      {items.map((r) => (
        <li key={r.key}>
          <Link to={r.to} data-testid={`reminder-${r.key}`} className="flex items-center gap-3 rounded-2xl px-4 py-3 bg-[var(--cream-surface)] border border-[var(--line)] transition-colors hover:bg-[var(--cream-card)]">
            <r.icon size={16} className={r.overdue ? "text-[var(--coral)]" : r.color ? "" : "text-[var(--teal)]"} style={r.color && !r.overdue ? { color: r.color } : undefined} />
            <span className={"text-sm flex-1 min-w-0 leading-snug" + (r.soon ? " font-semibold" : "")}>{r.text}</span>
            {r.amount != null && <Money value={r.amount} className="text-xs font-bold shrink-0" />}
          </Link>
        </li>
      ))}
    </ul>
  );
};
